import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["id", "name", "value", "defaultChecked", "checked", "indeterminate", "disabled", "readOnly", "className", "classes", "children", "variant", "inputProps", "onChange"];
import * as React from 'react';
import clsx from 'clsx';
import { Base } from '../../Base';
import { SrOnly } from '../../Helper';
import Svg from '../../Svg';
import { isNode } from '../../../helpers';
var stylesDefault = {
  "root": "CheckBox-root_27OrW",
  "trigger": "CheckBox-trigger_35ueK",
  "label": "CheckBox-label_3L9DF",
  "iconWrapper": "CheckBox-iconWrapper_23LQn",
  "icon": "CheckBox-icon_mNABM",
  "iconCheckmark": "CheckBox-iconCheckmark_MWJZv CheckBox-icon_mNABM",
  "iconDash": "CheckBox-iconDash_1-qAa CheckBox-icon_mNABM",
  "disabled": "CheckBox-disabled_2Jxg6"
};
var stylesBlock = {
  "root": "CheckBoxBlock-root_3HFGb",
  "trigger": "CheckBoxBlock-trigger_2UuNd",
  "label": "CheckBoxBlock-label_F-lA3",
  "iconWrapper": "CheckBoxBlock-iconWrapper_2mVeZ",
  "icon": "CheckBoxBlock-icon_31DD9",
  "iconCheckmark": "CheckBoxBlock-iconCheckmark_1UZe7 CheckBoxBlock-icon_31DD9",
  "iconDash": "CheckBoxBlock-iconDash_2VJMP CheckBoxBlock-icon_31DD9",
  "disabled": "CheckBoxBlock-disabled_uQX3m"
};
function CheckBox(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    defaultChecked = _ref.defaultChecked,
    checked = _ref.checked,
    _ref$indeterminate = _ref.indeterminate,
    indeterminate = _ref$indeterminate === void 0 ? false : _ref$indeterminate,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly,
    className = _ref.className,
    classes = _ref.classes,
    children = _ref.children,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'default' : _ref$variant,
    inputProps = _ref.inputProps,
    onChange = _ref.onChange,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var inputRef = React.useRef();
  React.useEffect(function () {
    if (isNode(inputRef.current)) {
      inputRef.current.indeterminate = indeterminate;
    }
  }, [indeterminate]);

  /**
   * Class helper to target child elements.
   */
  var classOf = function classOf(key) {
    return (classes === null || classes === void 0 ? void 0 : classes[key]) || '';
  };
  var hideLabel = /compact|block/.test(variant);
  var styles = variant === 'block' ? stylesBlock : stylesDefault;
  var rootClasses = clsx(styles.root, disabled && styles.disabled, className, classOf('root'));
  var triggerClasses = clsx(styles.trigger, classOf('trigger'));
  var labelClasses = clsx(styles.label, classOf('label'));
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      flex: true,
      gap: variant === 'default' ? 'spacing-2x' : undefined,
      position: "relative",
      className: rootClasses
    }, extraProps), /*#__PURE__*/React.createElement("input", _extends({
      type: "checkbox",
      id: id || name,
      name: name,
      value: value,
      defaultChecked: defaultChecked,
      checked: checked,
      disabled: disabled,
      readOnly: readOnly,
      className: triggerClasses,
      ref: inputRef,
      onChange: onChange
    }, inputProps)), /*#__PURE__*/React.createElement(Base, {
      tagName: "label",
      weight: "regular",
      className: labelClasses,
      htmlFor: id || name
    }, hideLabel ? /*#__PURE__*/React.createElement(SrOnly, null, children) : children), /*#__PURE__*/React.createElement(Base, {
      flex: true,
      flexJustifyCenter: true,
      flexAlignItemsCenter: true,
      className: styles.iconWrapper
    }, /*#__PURE__*/React.createElement(Svg, {
      name: "miniCheckmark",
      className: styles.iconCheckmark
    }), /*#__PURE__*/React.createElement(Svg, {
      name: "miniDash",
      className: styles.iconDash
    })))
  );
}
export default CheckBox;